import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/SURVEY') => `${reducer}/${actionType}`;

export const sendSuggestion = () => {
	return async (dispatch, getState) => {
		const suggestion = getState().page.survey.suggestion;
		const cellphone = +suggestion.phone;
		const code = +suggestion.code;
		const text = suggestion.message || '';

		const onOK = (data) => {
			dispatch({
				type: generateType('CLEAR'),
				payload: { scope: 'suggestion' },
			});
		};

		const onStatus = (status) => {
			dispatch({
				type: generateType('SET'),
				payload: { scope: 'suggestion', values: { _send: status } },
			});
		};

		await api.$suggestion_save({ onOK, onStatus, showOkMessage: true }, { code, cellphone, text });
	};
};

export const sendComplaint = () => {
	return async (dispatch, getState) => {
		const complaint = getState().page.survey.complaint;
		const cellphone = +complaint.phone;
		const code = +complaint.code;
		const text = complaint.message || '';

		const onOK = (data) => {
			dispatch({
				type: generateType('CLEAR'),
				payload: { scope: 'complaint' },
			});
		};

		const onStatus = (status) => {
			dispatch({
				type: generateType('SET'),
				payload: { scope: 'complaint', values: { _send: status } },
			});
		};

		await api.$complaint_save({ onOK, onStatus, showOkMessage: true }, { cellphone, code, text });
	};
};

export const sendOtp = (type = '', onOkCB = null) => {
	return async (dispatch, getState) => {
		const cellphone =
			type === 'suggestion' ? +getState().page.survey.suggestion?.phone : +getState().page.survey.complaint?.phone;

		const onOK = (data) => {
			dispatch({
				type: generateType('SET'),
				payload: { scope: type === 'suggestion' ? 'suggestion' : 'complaint', values: { showOtp: true } },
			});

			if (onOkCB) onOkCB();
		};

		const onStatus = (status) => {
			dispatch({
				type: generateType('SET'),
				payload: { scope: type === 'suggestion' ? 'suggestion' : 'complaint', values: { _send: status } },
			});
		};

		await api.$otp_send_customer({ onOK, onStatus, showOkMessage: true, okMessage: 'رمز یکبار مصرف با موفقیت ارسال شد' }, { cellphone });
	};
};

// export const sendSuggestion = () => {
// 	return async (dispatch, getState) => {
// 		const suggestion = getState().page.survey.suggestion;
// 		const message = getState().page.survey.message;
// 		const phone = getState().page.survey.phone;
// 		const code = getState().page.survey.code;

// 		const onOK = (data) => {
// 			dispatch({
// 				type: generateType('CLEAR'),
// 				payload: { scope: 'suggestion' },
// 			});
// 		};

// 		const onStatus = (status) => {
// 			dispatch({
// 				type: generateType('SET'),
// 				payload: { scope: 'suggestion', values: { _send: status } },
// 			});
// 		};

// 		await api.$suggestion_save({ onOK, onStatus, showOkMessage: true }, { text: message });
// 	};
// };

// export const sendComplaint = () => {
// 	return async (dispatch, getState) => {
// 		const { message } = getState().page.survey.complaint;

// 		const onOK = (data) => {
// 			dispatch({
// 				type: generateType('CLEAR'),
// 				payload: { scope: 'complaint' },
// 			});
// 		};

// 		const onStatus = (status) => {
// 			dispatch({
// 				type: generateType('SET'),
// 				payload: { scope: 'complaint', values: { _send: status } },
// 			});
// 		};

// 		await api.$complaint_save({ onOK, onStatus, showOkMessage: true }, { text: message });
// 	};
// };
